/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLayoutListFilled = createReactComponent("filled", "layout-list-filled", "IconLayoutListFilled", [["path", { "d": "M18 3a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-0" }], ["path", { "d": "M18 13a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3z", "key": "svg-1" }]]);

export { IconLayoutListFilled as default };
//# sourceMappingURL=IconLayoutListFilled.mjs.map
